import { QueryClient } from '@tanstack/react-query';
import { ApiRequestError } from '../api/client';

/**
 * Серверные данные живут только здесь (agents/web-shell.md §5).
 * Дублировать их в Zustand запрещено — это главный источник рассинхрона статусов.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // 4xx не ретраим: это бизнес-ответ, а не сбой
        if (error instanceof ApiRequestError && error.status >= 400 && error.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
    },
  },
});
